import React from 'react';
import styled from '@emotion/styled';
import { Tabs, Tab } from '@mui/material';
import { TabItem } from './TabItem';
import { ReactComponent as IconPain } from 'components/home/icons/pain.svg';
import { ReactComponent as IconWorry } from 'components/home/icons/worry.svg';
import { ReactComponent as IconMood } from 'components/home/icons/mood.svg';
import { ReactComponent as IconSleep } from 'components/home/icons/sleep.svg';
import { ReactComponent as IconSubstanceUse } from 'components/home/icons/substance-use.svg';

export const TABS = [
  { id: 'PI', text: { en: 'Pain', fr: 'Douleur' }, icon: <IconPain /> },
  { id: 'AQ', text: { en: 'Worry', fr: 'Inquiétude' }, icon: <IconWorry /> },
  { id: 'DS', text: { en: 'Mood', fr: 'Humeur' }, icon: <IconMood /> },
  { id: 'SQ', text: { en: 'Sleep', fr: 'Sommeil' }, icon: <IconSleep /> },
  {
    id: 'CQ',
    text: { en: 'Substance Use', fr: 'Substances' },
    icon: <IconSubstanceUse />,
  },
];

const TAB_TO_INDEX = {
  PI: 0,
  AQ: 1,
  DS: 2,
  SQ: 3,
  CQ: 4,
  BSCQ: 4,
  undefined: false,
};

const StyledTabs = styled(Tabs)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  span.MuiTabs-indicator {
    display: none;
  }

  .MuiTabs-flexContainer {
    margin-inline: auto;
    width: fit-content;
  }
`;

const StyledTabItemWrapper = styled(Tab)`
  &.Mui-selected {
    * {
      opacity: 1;
    }
  }
`;

export const QuestionTab = ({ tab, language }) => {
  return (
    <StyledTabs
      value={TAB_TO_INDEX[tab]}
      data-testid="question-tabs"
      sx={{
        p: {
          xs: '2rem',
          sm: '2rem 2.25rem',
          md: '3rem 3.75rem',
          lg: '3rem 5.625rem',
        },
      }}
    >
      {TABS.map((tab, index) => (
        <StyledTabItemWrapper
          key={index}
          label={
            <TabItem
              role="tab"
              icon={tab.icon}
              index={index + 1}
              label={language === 'FRENCH' ? tab.text.fr : tab.text.en}
              language={language}
              totalItems={TABS.length}
            />
          }
          data-testid={`b-navigation__tab-${index}`}
          aria-controls={`b-navigation__tab-panel-${index}`}
        />
      ))}
    </StyledTabs>
  );
};
